import React from "react";
import { useAppSelector } from "store/hooks";
import { selectIsManager } from "store/reducers/config/configSlice";
import { OvertimeNoteModal } from "timesheet_viewer/OvertimeNoteModal";

import { Button } from "./button";
import { OvertimeButtons, OvertimeParent } from "./OvertimeButtons";
import { OvertimeStatusButton } from "./OvertimeStatusButton";

type Props = {
  date: string;
  timesheetEmployeeId: number;
  currentEmployeeId?: number;
  overtime?: Overtime;
  parent?: OvertimeParent;
  overtimeDuration?: number | null;
};

/**
 * OvertimeDay displays "Apply Overtime" button in DaySummaryRow component
 */
export function OvertimeDay(props: Props) {
  const {
    date,
    timesheetEmployeeId,
    currentEmployeeId,
    overtime,
    parent = "TIMESHEET",
    overtimeDuration = null,
  } = props;

  const [overtimeModalIsOpen, setOvertimeModalIsOpen] = React.useState(false);
  const isManager = useAppSelector(selectIsManager);

  function onClickOvertime() {
    if (parent === "MODAL") return; // We don't open the modal from within the modal
    setOvertimeModalIsOpen(true);
  }

  return (
    <div data-track-context="timesheet.overtime">
      {/* Overtime status view for managers and requesting employees */}
      {overtime && (parent === "TIMESHEET" || parent === "MODAL") && (
        <OvertimeStatusButton overtime={overtime} onClick={onClickOvertime} />
      )}

      {/* Manager and employee need to apply overtime */}
      {(currentEmployeeId === timesheetEmployeeId || isManager) && overtimeDuration && !overtime && (
        <Button
          data-track="open_apply"
          onClick={() => setOvertimeModalIsOpen(true)}
          colour="accent"
          size="sm"
          title="Click here to request overtime approval"
        >
          Apply Overtime
        </Button>
      )}

      <OvertimeButtons
        date={date}
        timesheetEmployeeId={timesheetEmployeeId}
        currentEmployeeId={currentEmployeeId}
        overtime={overtime}
        parent={parent}
        overtimeDuration={overtimeDuration}
      />
      {overtimeModalIsOpen && (
        <OvertimeNoteModal
          isOpen={overtimeModalIsOpen}
          dismissModal={() => setOvertimeModalIsOpen(false)}
          day={date}
          employeeId={timesheetEmployeeId}
          title="Overtime Shift Notes"
          overtimeDuration={overtimeDuration}
          overtime={overtime}
        />
      )}
    </div>
  );
}
